export default __webpack_public_path__ + "static/media/HeroImage.460a98db.jpg";